import Alert from '@vizuaalog/bulmajs/src/plugins/alert';
import u from 'umbrellajs';
import { uniqWith, isEqual, find } from 'lodash';

import {
	checkElement2,
	wrap,
	hideElement,
	showElement,
	findGrapesJSComponent,
	hideGrapesJSComponent,
	showGrapesJSComponent,
	checkElement2WithBoundingRect,
	getWindowWidthHeight
} from './domUtils';

const changeColorPickerUsingIcon = colorPickerSelector => {
	const colorPickerElement = document.querySelector(colorPickerSelector);
	if (!colorPickerElement) return;
	let svgContent = null;
	if (colorPickerSelector.includes('gjs-sm-color')) {
		svgContent = `
                <svg
                  focusable="false"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                  role="presentation"
                >
                  <path d="M0 20h24v4H0z" style="fill: white" stroke="white"></path>
                  <path
                    d="M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z" style="fill: white"
                  ></path>
                </svg>
              `;
	} else if (colorPickerSelector.includes('gjs-sm-background-color')) {
		svgContent = `
              <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                <path d="M0 20h24v4H0z" style="fill: white" stroke="white"></path>
                <path style="fill: white" d="M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z"></path>
              </svg>
              `;
	} else if (colorPickerSelector.includes('gjs-sm-border-color')) {
		svgContent = `
              <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                <path style="fill: white" d="M0 20h24v4H0z" stroke="white"></path>
                <path style="fill: white" d="M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96c.39-.39.39-1.02 0-1.41L18.37.29a.9959.9959 0 0 0-1.41 0L15 2.25 18.75 6l1.96-1.96z"></path>
              </svg>
              `;
	}

	// check if already add icons or not
	const svg = colorPickerElement.querySelector('svg');
	// if (svg) {
	//   svg.remove();
	// }
	if (!svg) {
		const colorPickerSvg = document.createTextNode('');
		colorPickerSvg.innerHTML = svgContent;
		colorPickerElement.insertAdjacentHTML('beforeend', colorPickerSvg.innerHTML);
	}
};

const convertSelectBoxToBulmaStyle = () => {
	const allSelect = document.querySelectorAll('select');
	allSelect.forEach(select => {
		const outerDiv = document.createElement('div');
		outerDiv.classList.add('select');
		wrap(select, outerDiv);
	});
};

const hideColorPickerDialog = () => {
	const borderColorElement = u(".sp-container:not([class*='sp-hidden'])").first();
	if (borderColorElement) {
		// color dialog is showing, hide it
		const selectorBorderColor = '.gjs-sm-border-color-color-picker';
		u(selectorBorderColor).trigger('click');
	}
};

const addHrefTraitButtonToBlueBox = (editor, component) => {
	if (component.is('link')) {
		const commands = editor.Commands;
		commands.add('editHref', () => {
			console.log('editHref click');

			const componentHref = component.getAttributes().href;
			// console.log('component.getAttributes()', componentHref);
			const body = `
       <div>
        <div>
          <input class="input href-component" type="text" placeholder="Url" value="${componentHref}">
        </div>
       </div>
    `;
			// eslint-disable-next-line no-unused-vars
			const alert = new Alert({
				type: 'info',
				title: 'Set Url',
				body,
				confirm: {
					label: 'Save',
					destroy: true,
					onClick() {
						const hrefValue = u('.href-component').first().value;
						// console.log(hrefValue);

						// set component attribute
						component.setAttributes({ href: hrefValue });

						// Bug in alert js, manually destroy alert
						// keep eye on https://github.com/VizuaaLOG/BulmaJS/blob/0.10.x/src/plugins/alert.js
						u('.modal.alert').remove();
					}
				},
				cancel: {
					label: 'Cancel'
				}
			});
		});

		let toolbar = component.get('toolbar');
		toolbar = uniqWith(
			[...toolbar, { attributes: { class: 'fa fa-link' }, command: 'editHref' }],
			isEqual
		);
		component.set({
			toolbar
		});
	}
};

const configGJSToolbar = (editor, component) => {
	addHrefTraitButtonToBlueBox(editor, component);

	let toolbar = component.get('toolbar');
	// console.log('component', component.get('type'), component);
	toolbar = toolbar.filter(value => {
		// console.log('component:selected toolbar value', className);

		// if (window.GM_BRANDING_TYPE_REPORT_EBOOK) {
		// const className = value.attributes.class;
		// 	// bring back move button for report cover
		// 	return !className.includes('fa-arrow-up');
		// }

		const removableComponent =
			window.GM_BRANDING_TYPE_REPORT_EBOOK && component.get('removable');
		const draggableComponent =
			window.GM_BRANDING_TYPE_REPORT_EBOOK && component.get('draggable');
		const copyableComponent = window.GM_BRANDING_TYPE_REPORT_EBOOK && component.get('copyable');
		// console.log('configGJSToolbar', {
		// 	value,
		// 	removableComponent,
		// 	draggableComponent,
		// 	copyableComponent
		// });
		if (value.command === 'tlb-move') {
			return draggableComponent;
		}
		if (value.command === 'tlb-delete') {
			return removableComponent;
		}
		if (value.command === 'tlb-clone') {
			return copyableComponent;
		}
		return false;

		// return !(className.includes('fa-arrow-up') || className.includes('fa-arrows'));
	});
	if (window.GM_BRANDING_TYPE_REPORT_EBOOK) {
		if (
			component.is('image') &&
			component.get('editable') &&
			!find(toolbar, { command: 'openChangeBackgroundDialog' })
		) {
			toolbar.unshift({
				attributes: { class: 'fa fa-pencil-square gjs-no-touch-actions' },
				command: 'openChangeBackgroundDialog'
			});
		}
	}
	console.log('configGJSToolbar', toolbar);
	component.set({ toolbar });
};

const removeTraits = component => {
	component.removeTrait(['title', 'id', 'target', 'alt']);
};

const doChangeColorPickersUsingIcon = () => {
	changeColorPickerUsingIcon('#gjs-sm-color .gjs-field-color-picker');
	changeColorPickerUsingIcon('#gjs-sm-background-color .gjs-field-color-picker');
	changeColorPickerUsingIcon('#gjs-sm-border-color .gjs-field-color-picker');
};

const syncFontWeight = () => {
	// should initialize font weight checkbox base on radio value
	const selector700 = "input[id*='font-weight-700']";
	// const selector400 = "input[id*='font-weight-400']";
	checkElement2(selector700).then(() => {
		const fontWeight700Checked = document.querySelector(selector700).checked;
		const fontWeightCheckBox = document.querySelector('.font-weight-checkbox');
		if (!fontWeightCheckBox) return;
		if (fontWeight700Checked) {
			fontWeightCheckBox.classList.add('bold');
			// document.querySelector(selector700).click();
		} else {
			fontWeightCheckBox.classList.remove('bold');
			// document.querySelector(selector400).click();
		}
	});
};

// const setReadOnlyButDraggableComponent = component => {
// 	setReadOnlyComponent(component, true);
// };

// const setReadOnlyNonDraggableComponent = component => {
// 	setReadOnlyComponent(component, false);
// };

const hideOrShowSlashComponent = component => {
	const componentClasses = component.getClasses();
	// console.log('doInComponentSelected', componentId, componentClasses);
	if (componentClasses.includes('introduction') || componentClasses.includes('more-info')) {
		const slashComp = findGrapesJSComponent('.about-right .slash');
		hideGrapesJSComponent(slashComp);
	} else {
		const slashComp = findGrapesJSComponent('.about-right .slash');
		showGrapesJSComponent(slashComp);
	}
};

const handleClickOnBackToTop = (component, editor) => {
	const isBackToTop = component.getAttributes()?.['data-id'] === 'backToTop';
	// console.log('handleClickOnBackToTop', isBackToTop);
	if (isBackToTop) {
		window.grapesjs.Canvas.getWindow().backToTopFunction();
		editor.selectRemove(component);
	}
};

const fixCKEditorToolBarPosition = selectedDOMElement => {
	const textRect = selectedDOMElement.getBoundingClientRect();
	const {
		width: selectedElementWidth,
		top: selectedElementTop,
		bottom: selectedElementBottom
	} = textRect;

	setTimeout(() => {
		checkElement2WithBoundingRect('.gjs-rte-toolbar', 100).then(element => {
			const { windowWidth } = getWindowWidthHeight();
			const toolbarRect = element.getBoundingClientRect();
			const { x, y: elementTopLeft, width, height: toolbarHeight } = toolbarRect;
			let toolbarTop;
			// // Try to place the toolbar above the text element
			// if (textRect.top - toolbarRect.height >= 0) {
			// 	// Place toolbar above
			// 	toolbarTop = textRect.top - toolbarRect.height;
			// } else {
			// 	// Not enough space above, place toolbar below
			// 	toolbarTop = textRect.bottom;
			// }
			// // element.style.position = 'absolute';
			// // Apply the calculated positions to the toolbar
			// element.style.top = `${toolbarTop}px`;
			if (toolbarRect.y - toolbarRect.height > 0) {
				element.style.top = `-${toolbarRect.height}px`;
			}

			let left;
			if (x + width > windowWidth) {
				left = selectedElementWidth - width;
				element.style.left = `${left}px`;
			}
		});
	}, 300);
};

export const doInComponentSelected = (editor, component) => {
	console.log('doInComponentSelected', component.getAttributes());

	// hideTopBarMenu();
	hideColorPickerDialog();
	removeTraits(component);

	doChangeColorPickersUsingIcon();
	syncFontWeight();
	convertSelectBoxToBulmaStyle();

	// Change href trait to url
	const selectorStr = 'div[title="Href"]';
	checkElement2(selectorStr).then(() => {
		u(selectorStr)
			.attr('title', 'Url')
			.text('Url');
	});

	// in report mode, when click body hide background color
	if (window.GM_BRANDING_TYPE_REPORT_EBOOK) {
		const componentId = component.getId();
		// const componentClasses = component.getClasses();

		// console.log('componentIdcomponentClasses', componentId, componentClasses);
		if (componentId === 'wrapper') {
			hideElement('#gjs-sm-background-color'); // hide background color
			// hideElement("span[title='Undo']"); // hide undo
			// hideElement("span[title='Redo']"); // hide redo
		} else {
			showElement('#gjs-sm-background-color');
		}
	} else {
		// Template mode
		hideOrShowSlashComponent(component); // temporary disable slash component for template 1

		// disable bluebox for text component and menu links in template mode
		const href = component.getAttributes().href || '';
		const isMenuLink = href.startsWith('#section-');
		// if (component.is('text') || isMenuLink) {
		if (isMenuLink) {
			component.set({
				toolbar: []
			});
		}
	}

	configGJSToolbar(editor, component);

	if (component.is('text') || component.is('unchangeable')) {
		// one click activate edit mode for text component
		component.getView().onActive();

		fixCKEditorToolBarPosition(component.getEl());
	}

	// Click Scroll to top button
	handleClickOnBackToTop(component, editor);
};
